__turbopack_context__.v({
  "antd": "antd-module-scss-module__hF1KDG__antd",
  "primaryButton": "antd-module-scss-module__hF1KDG__primaryButton",
});
